module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-3.0c8a859e.jpg";